<template>
<div>
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
        <v-btn round color="primary" @click="addOrganisationModal=true">
            Add Organisation
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :search="search"
        :items="organisations"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
            <v-icon small @click="viewReportsItem(props.item)">remove_red_eye</v-icon>
          </td>
            <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.organisationType.name}}</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
           <td @click="routerLinkToDetails(props.item)" class="truncate" >{{props.item.description}}</td>
           <td @click="changeActiveStatus(props.item)" class="text-xs-center">
             <v-chip class="white--text" v-if="props.item.isActive" color="light-green">Active</v-chip>
             <v-chip class="white--text" v-else color="red">Inactive</v-chip>
             </td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addOrganisationModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD ORGANISATION</h1></v-toolbar>
              <v-card-text>
                  <v-select v-model="item.organisationTypeId" :items="organisationtypes" item-text="name" item-value="id" label="Organisation Type"></v-select>
                  <v-text-field label="Organisation Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
                  <v-switch label="Customer" v-model="item.isCustomer"></v-switch>
                  <v-switch label="Supplier" v-model="item.isSupplier"></v-switch>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addOrganisationModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveOrganisation">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog v-model="viewReportsModal" width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">Report: {{item.name}}</h1></v-toolbar>
              <v-toolbar flat color="white" class="mt-1">
                <v-flex xs6>
        <v-menu>
          <v-text-field
            :value="this.setDate"
            slot="activator"
            label="Select Month to Report"
            prepend-icon="date_range"
            required
          ></v-text-field>
          <v-date-picker v-model="setDate" type="month"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm4 md4>
        <v-select v-model="item.reportType" :items="reportTypes" item-text="name" label="Report Type"></v-select>
      </v-flex>
      <v-flex xs12 sm4 md4>
        <v-select v-if="typeof item.reportType !== 'undefined'&&item.reportType!=='Service Accounts'" v-model="item.reportDetail" :items="reportDetail" item-text="name" label="Report Detail"></v-select>
      </v-flex>
      <v-btn v-if="setDate&&typeof item.reportType!=='undefined'&&item.reportType!=='Service Accounts'&&item.reportDetail" @click="viewTransactionReports" class="primary" round>Get Report</v-btn>
      <v-btn v-if="setDate&&typeof item.reportType!=='undefined'&&item.reportType==='Service Accounts'" @click="viewServiceAccountReports" class="primary" round>Get Report</v-btn>
              </v-toolbar>
              <v-toolbar flat color="white">
                <v-btn v-show="allBilling.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="allBilling"
            :fields="exportFields"
            worksheet="export"
            :name="'Billing_'+new Date().getTime()+'.xls'"
          >Export Service Accounts to Excel</download-excel>
        </v-btn>
        <!-- <v-btn v-show="initialTransactions.length>0&&item.reportType===('Transactions as Supplier'||'Transactions as Customer')" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="initialTransactions"
            :fields="transactionExportFields"
            worksheet="export"
            :name="'Transactions_'+new Date().getTime()+'.xls'"
          >Export Transactions to Excel</download-excel>
        </v-btn> -->
        <v-btn v-show="initialTransactions.length>0&&(item.reportType==='Transactions as Supplier'||item.reportType==='Transactions as Customer')" round color="primary">
          <v-icon>get_app</v-icon>
        <download-excel
    :data="initialTransactions"
    :fields="transactionExportFields"
    :name="'Transactions_'+new Date().getTime()+'.xls'">
    Export Transactions to Excel
</download-excel>
      </v-btn>
        <v-btn v-show="initialTransactions.length>0&&item.reportType===('Own Transactions')" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="initialTransactions"
            :fields="ownTransactionExportFields"
            worksheet="export"
            :name="'Transactions_'+new Date().getTime()+'.xls'"
          >Export Transactions to Excel</download-excel>
        </v-btn>
              </v-toolbar>
               <v-toolbar flat class="white py-3" v-if="initialTransactions.length>0">
      <v-flex xs12 sm12 md12 >
          <v-container grid-list-xs>
            <v-layout wrap>
      
      <v-flex xs3 sm3 md3 lg3 my-4>
        <v-card flat color="white">
          <h3>Total Sales:</h3>
          <h3 class="green--text">{{totalSales|currency}}</h3>
          </v-card>
      </v-flex>
      <v-flex xs3 sm3 md3 lg3 my-4>
        <v-card flat color="white">
          <h3>Total Cost of Sales:</h3>
          <h3 class="red--text">{{totalCos|currency}}</h3>
        </v-card>
      </v-flex>
      <v-flex xs3 sm3 md3 lg3 my-4>
        <v-card flat color="white">
          <h3>Total Expenses:</h3>
          <h3 class="red--text">{{totalExpenses|currency}}</h3>
        </v-card>
      </v-flex>
     <v-flex xs3 sm3 md3 lg3 my-4>
        <v-card flat color="white">
          <h3>Total Profit/Loss:</h3>
          <h3
            class="green--text"
            v-if="calculateGP(totalSales, totalCos, totalExpenses)>0"
          >{{calculateGP(totalSales, totalCos, totalExpenses)|currency}}</h3>
          <h3
            class="red--text"
            v-else
          >{{calculateGP(totalSales, totalCos, totalExpenses)|currency}}</h3>
        </v-card>
      </v-flex>
      </v-layout>
          </v-container>
        </v-flex>
    </v-toolbar>
      <v-data-table
      v-if="initialTransactions.length>0 &&(item.reportType==='Transactions as Supplier'||item.reportType==='Transactions as Customer')"
      disable-initial-sort
      :headers="transactionHeaders"
      :items="initialTransactions"
      item-key="name"
      :key="key"
      :rows-per-page-items="[10, 25, 50, 100, 250]"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{formatDate(props.item.date)}}</td>
        <td class="text-xs-center">{{props.item.locationNode.name}}</td>
        <td class="text-xs-center" v-if="props.item.locationNetwork !== null">{{props.item.locationNetwork.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.location !== null">{{props.item.location.locationDescription}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.amount|currency}}</td>
      </template>
    </v-data-table>
    <v-data-table
      v-if="initialTransactions.length>0 &&item.reportType===('Own Transactions')"
      disable-initial-sort
      :headers="ownTransactionHeaders"
      :items="initialTransactions"
      item-key="name"
      :key="key"
      :rows-per-page-items="[10, 25, 50, 100, 250]"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{formatDate(props.item.date)}}</td>
        <td class="text-xs-center" v-if="props.item.locationNode!==null">{{props.item.locationNode.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.locationNetwork!==null">{{props.item.locationNetwork.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.location!==null">{{props.item.location.locationDescription}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.transactionType}}</td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center green--text" v-if="props.item.transactionType==='Sales'">{{props.item.amount|currency}}</td>
        <td class="text-xs-center red--text" v-else>{{props.item.amount|currency}}</td>
      </template>
    </v-data-table>
    <v-data-table
    v-if="item.reportType==='Service Accounts'"
        :headers="serviceAccHeaders"
        class="elevation-1"
        :items="allBilling"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
        :key="key"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon @click="edit(props.item)">edit</v-icon>
          </td>
          <td class="text-xs-center" v-if="props.item.isActive">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.packagesIsp.customerOrganisation.name}}</td>
          <td class="text-xs-center">{{props.item.location.unitNo}}</td>
          <td class="text-xs-center">{{props.item.location.locationNetwork.name}}</td>
          <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.packageCode}}</td>
          <td
            class="text-xs-center"
          >{{props.item.packagesIsp.packagesFno.packageBasePrice | currency}}</td>
          <td class="text-xs-center">{{formatDate(props.item.initialActivation)}}</td>
          <td
            class="text-xs-center"
            v-if="(props.item.fnoDeactivationDate!==null||props.item.ispDeactivationDate!==null)
      &&(new Date(props.item.fnoDeactivationDate)>new Date(props.item.ispDeactivationDate))
      "
          >{{formatDate(props.item.fnoDeactivationDate)}}</td>
          <td
            class="text-xs-center"
            v-else-if="(props.item.fnoDeactivationDate!==null||props.item.ispDeactivationDate!==null)
      &&(new Date(props.item.fnoDeactivationDate)<new Date(props.item.ispDeactivationDate))
      "
          >{{formatDate(props.item.ispDeactivationDate)}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{formatDate(new Date(props.item.startDate))}}</td>
          <td class="text-xs-center">{{formatDate(new Date(props.item.endDate))}}</td>
          <td class="text-xs-center">{{props.item.onceOff|currency}}</td>
          <td class="text-xs-center">{{props.item.prorata|currency}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="viewReportsModal=false,setDate=null,totalSales=0,totalCos=0,totalExpenses=0,grossProfit=0">Cancel</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
</div>
  
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    props: ['organisations', 'organisationtypes'],
    data(){
        return {
            addOrganisationModal:false,
            item: {
              isCustomer: true,
              isSupplier: false
            },
            search: '',
            viewReportsModal: false,
            setDate: null,
            startDay: null,
            endDay: null,
            totalSales: 0,
            totalCos: 0,
            totalExpenses: 0,
            grossProfit: 0,
            initialTransactions: [],
            allBilling: [],
            key: 0,
            reportDetail: ['Node', 'Network', 'End Locations'],
            reportTypes: ['Service Accounts', 'Own Transactions','Transactions as Customer', 'Transactions as Supplier'],
            ownTransactionExportFields: {
              'transactionDate': 'date',
        'node': 'locationNode.name',
        'network': 'locationNetwork.name',
        'unit': 'location.locationDescription',
        'transactionType': 'transactionType',
        'description': 'description',
        'amount': 'amount'
            },
            transactionExportFields: {
        'transactionDate': 'date',
        'node': 'locationNode.name',
        'network': 'locationNetwork.name',
        'unit': 'location.locationDescription',
        'initialActivation': 'serviceAccount.initialActivation',
        'packageSpeed': 'serviceAccount.packagesIsp.packagesFno.speedProfile.name',
        'commission': 'amount'
        },
      exportFields: {
        id: "id",
        node: "location.locationNetwork.locationNode.name",
        network: "location.locationNetwork.name",
        unit: {
          callback: value => {
            if (value.location.locationNetworkSubComplexId !== null) {
              return (
                value.location.unitNo +
                " " +
                value.location.locationNetworkSubComplex.subComplexName
              );
            } else {
              return value.location.unitNo;
            }
          }
        },
        ispName: "packagesIsp.customerOrganisation.name",
        pppoeUsername: "pppoeUsername",
        fnoPackage: "packagesIsp.packagesFno.packageCode",
        initialActivation: {
          callback: value => {
            return this.formatDate(value.initialActivation);
          }
        },
        ispActivation: {
          callback: value => {
            return this.formatDate(value.ispActivationDate);
          }
        },
        ispDeactivation: {
          callback: value => {
            return this.formatDate(value.ispDeactivationDate);
          }
        },
        fnoActivation: {
          callback: value => {
            return this.formatDate(value.fnoActivationDate);
          }
        },
        fnoDeactivation: {
          callback: value => {
            return this.formatDate(value.fnoDeactivationDate);
          }
        },
        fnoPackagePrice: {
          callback: value => {
            if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.residentialLineRentalValue
              );
            } else if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.businessLineRentalValue
              );
            } else {
              return value.packagesIsp.packagesFno.packageBasePrice;
            }
          }
        },
        billedFrom:  {
          callback: value => {
            return this.formatDate(value.startDate);
          }
        },
        billedTo: {
          callback: value => {
            return this.formatDate(value.endDate);
          }
        },
        "Data Activation Fee": 'onceOff',
        "VAS Billed": 'prorata'
          
        
      },
            headers: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        
        {
          text: "Type",
          align: "center",
          value: "organisationType.name"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Status",
          align: "center",
          value: "isActive"
        }
        ],
        serviceAccHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        },
        {
          text: "ISP Name",
          align: "center",
          value: "packagesIsp.customer.name"
        },
        {
          text: "Unit No",
          align: "center",
          value: "location.unitNo"
        },
        {
          text: "Network",
          align: "center",
          value: "location.locationNetwork.name"
        },

        {
          text: "FNO Package Code",
          align: "center",
          value: "packagesIsp.packagesFno.packageCode"
        },
        {
          text: "FNO Package price",
          align: "center",
          value: "packagesIsp.packagesFno.packageBasePrice"
        },
        {
          text: "Initial Account Activation",
          align: "center",
          value: "initialActivation"
        },
        {
          text: "Account Deactivation",
          align: "center",
          value: "fnoDeactivationDate"
        },
        {
          text: "Billing Start",
          align: "center",
          value: "startDate"
        },
        {
          text: "Billing End",
          align: "center",
          value: "endDate"
        },
        {
          text: "Once-Off Fee Billed ex VAT",
          align: "center",
          value: 'onceOff'
        },
        {
          text: "Recurring VAS Fee Billed ex VAT",
          align: "center",
          value: 'prorata'
        }
      ],
      ownTransactionHeaders : [
         {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Location Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Location Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationdescription"
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "transactionType"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          value: "Amount"
        }
      ],
        transactionHeaders: [
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Location Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Location Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationdescription"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          value: "Amount"
        }
      ],
        }
    },
    methods: {
        deleteItem(item){
          confirm("Are you sure you would like to remove this organisation?")&&
            Api()
            .put('/organisation/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.$emit('organisationChange'))
        },
        calculateGP(sales, cos, exp) {
      return sales - cos - exp;
    },
        saveOrganisation(){
          if(this.authenticateSystemAdmin(this.$store.state.user)){
            Api()
            .post('/organisation',{
                name: this.item.name,
                description: this.item.description,
                organisationTypeId: this.item.organisationTypeId,
                primaryColour: '#00a3da',
                secondaryColour: '#f7bf34',
                navbarColour: '#31322F',
                navbarTextColour: '#ffffff',
                primaryOrganisationId: this.$store.state.currentOrg.org.id,
                isCustomer: this.item.isCustomer,
                isSupplier: this.item.isSupplier,
                isActive: true,
                isDelete: false
            }).then(response=>{
              Api()
              .post('/userRole',{
                name: 'Admin',
                description: 'Default Admin Role',
                userGroupId: 4,
                isAdmin: true,
                organisationId: response.data.id,
                isActive: true,
                isDelete: false
              })
              this.generateOrganisationToken(response.data)
              this.addOrganisationModal=false,
              this.item={},
              this.$emit('organisationChange')})
          } else if (this.authenticateOrganisationAdmin(this.$store.state.user)){
            Api()
            .post('/organisation',{
                name: this.item.name,
                description: this.item.description,
                organisationTypeId: 3,
                primaryColour: '#99cc33',
                secondaryColour: '#c2c7bd',
                navbarColour: '#7a7676',
                navbarTextColour: '#ffffff',
                primaryOrganisationId: this.$store.state.currentOrg.org.id,
                isActive: true,
                isDelete: false
            }).then(response=>{
              Api()
              .post('/userRole',{
                name: 'Admin',
                description: 'Default Admin Role',
                userGroupId: 4,
                isAdmin: true,
                organisationId: response.data.id,
                isActive: true,
                isDelete: false
              })
              this.generateOrganisationToken(response.data)
              this.addOrganisationModal=false,
              this.item={},
              this.$emit('organisationChange')
            })
          }
        },
        generateOrganisationToken(item){
      Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name,
        description: item.description
      })
      .then(response=>{
        let token=response.data.token
        Api()
        .put('/organisation/'+item.id,{
          token: token
        })
      })
    },
        routerLinkToDetails(item) {
          if(this.$route.path==='/organisation/isp'){
            this.$router.push({ path: "/organisation/isp/" + item.id });
          } else {
            this.$router.push({ path: "/organisations/" + item.id });
          }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    viewReportsItem(item){
      this.viewReportsModal=true
      this.item = Object.assign({}, item);
    },
    changeActiveStatus(item){
      let index = this.organisations.indexOf(item)
      this.organisations[index].isActive = !this.organisations[index].isActive
      Api()
      .put('/organisation/'+item.id,{
        isActive: this.organisations[index].isActive
      })
    },
    async viewTransactionReports(item){
      let initialDate = new Date(this.setDate)
          let selectedDate = new Date(initialDate.getFullYear(),
            initialDate.getMonth(),
            25, 2);
          
          (this.startDay = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            26
          )),
          
            (this.endDay = new Date(
              selectedDate.getFullYear(),
              selectedDate.getMonth(),
              25
            ));
            var endDay = this.endDate
            var startDay = this.startDay
            
          
          let date = new Date(
            this.startDay.getFullYear(),
            this.startDay.getMonth(),
            0
          );
          if(this.item.reportType==='Transactions as Supplier'){
            if(this.item.reportDetail==='Node'){
              await Api()
              .get('/transactions/byCustomer/asSupplier/node/'+this.item.id,{
                params: {
                  billingDate: this.setDate
                }
              })
              .then(response=>{
                this.item.transactions=response.data
                this.initialTransactions=response.data
                this.key += 1
              })
            } else if (this.item.reportDetail==='Network'){
              await Api()
              .get('/transactions/byCustomer/asSupplier/network/'+this.item.id,{
                params: {
                  billingDate: this.setDate
                }
              })
              .then(response=>{
                this.item.transactions=response.data
                this.initialTransactions=response.data
                this.key += 1
              })
            } else if (this.item.reportDetail==='End Locations'){
              await Api()
              .get('/transactions/byCustomer/asSupplier/endLocations/'+this.item.id,{
                params: {
                  billingDate: this.setDate
                }
              })
              .then(async response=>{
                this.item.transactions=response.data
                this.initialTransactions=response.data
                // await response.data.filter(function(el){
                //   return new Date(el.date) <= new Date(selectedDate) && new Date(el.date) >= new Date(startDay)
                // })

                this.key += 1
              })
            }
            
          } else if (this.item.reportType==='Own Transactions'){
            if(this.item.reportDetail==='Node'){
              await Api()
      .get('/transactions/byCustomer/allOwn/node/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
            }
            else if(this.item.reportDetail==='Network'){
              await Api()
      .get('/transactions/byCustomer/allOwn/network/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
            }
            else if(this.item.reportDetail==='End Locations'){
              await Api()
      .get('/transactions/byCustomer/allOwn/endLocations/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
            }
          } else if(this.item.reportType==='Transactions as Customer'){
            if(this.item.reportDetail==='Node'){
              await Api()
      .get('/transactions/byCustomer/asCustomer/node/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
            }
              else if(this.item.reportDetail==='Network'){
                await Api()
      .get('/transactions/byCustomer/asCustomer/network/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
              }
                else if(this.item.reportDetail==='End Locations'){
                  await Api()
      .get('/transactions/byCustomer/asCustomer/endLocations/'+this.item.id)
      .then(response=>{
        this.item.transactions=response.data
        this.initialTransactions=response.data
        this.key += 1
      })
                }
            }
            this.sum()
      
    },
    viewServiceAccountReports(item){
          
      Api()
      .get('/serviceAccounts/billing/'+this.item.id)
      .then(async response=>{
        this.item.serviceAccounts=response.data
        this.allBilling = response.data;
              for (let i = 0; i < this.allBilling.length; i++) {
                //   Recurring Billing
                this.allBilling[i].prorata = await this.calcuateRecurringBills(
                  this.allBilling[i]
                );
                // Once Off Activations
                if (
                  new Date(this.allBilling[i].initialActivation) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].initialActivation) >=
                    new Date(this.startDay) &&
                  this.allBilling[i].isChange === false
                ) {
                  this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                } else if (
                  new Date(this.allBilling[i].initialActivation) ===
                    new Date(this.endDay) ||
                  new Date(this.allBilling[i].initialActivation) ===
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                } else {
                  this.allBilling[i].onceOff = 0;
                }
                // Start Date
                if(new Date(this.allBilling[i].initialActivation)>=new Date(this.startDay)){
                    this.allBilling[i].startDate=this.allBilling[i].initialActivation
                } else {
                    this.allBilling[i].startDate=this.startDay
                }
                // End Date
                if((this.allBilling[i].fnoDeactivationDate!==null &&this.allBilling[i].ispDeactivationDate===null
          &&new Date(this.allBilling[i].fnoDeactivationDate)<=new Date(this.endDay)&&new Date(this.allBilling[i].fnoDeactivationDate)>=new Date(this.startDay))){
              this.allBilling[i].endDate=this.allBilling[i].fnoDeactivationDate
          } else if ((this.allBilling[i].fnoDeactivationDate===null &&this.allBilling[i].ispDeactivationDate!==null
          &&new Date(this.allBilling[i].ispDeactivationDate)<=new Date(this.endDay)&&new Date(this.allBilling[i].ispDeactivationDate)>=new Date(this.startDay))){
              this.allBilling[i].endDate=this.allBilling[i].ispDeactivationDate
          } else if((this.allBilling[i].fnoDeactivationDate!==null &&this.allBilling[i].ispDeactivationDate!==null)
          &&(new Date(this.allBilling[i].fnoDeactivationDate)>=new Date(this.allBilling[i].ispDeactivationDate)
          &&new Date(this.allBilling[i].fnoDeactivationDate)<=new Date(this.endDay)&&new Date(this.allBilling[i].fnoDeactivationDate)>=new Date(this.startDay))){
              this.allBilling[i].endDate=this.allBilling[i].fnoDeactivationDate
          } else if((this.allBilling[i].fnoDeactivationDate!==null &&this.allBilling[i].ispDeactivationDate!==null)
          &&(new Date(this.allBilling[i].fnoDeactivationDate)<=new Date(this.allBilling[i].ispDeactivationDate)
          &&new Date(this.allBilling[i].ispDeactivationDate)<=new Date(this.endDay)&&new Date(this.allBilling[i].ispDeactivationDate)>=new Date(this.startDay))){
              this.allBilling[i].endDate=this.allBilling[i].ispDeactivationDate
          } else {
              this.allBilling[i].endDate=this.endDay
          }
              }
      })
    },
    async calcuateRecurringBills(item) {
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.initialActivation) >= new Date(this.startDay)) {
        this.startDate = new Date(item.initialActivation);
      } else {
        this.startDate = new Date(this.startDay);
      }
      if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate === null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      } else if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate !== null &&
        new Date(item.ispDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.ispDeactivationDate);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate !== null
      ) {
        if (
          new Date(item.fnoDeactivationDate) > new Date(this.endDay) &&
          new Date(item.ispDeactivationDate) > new Date(this.endDay)
        ) {
          this.endDate = new Date(this.endDay);
        } else if (
          new Date(item.fnoDeactivationDate) >=
          new Date(item.ispDeactivationDate)
        ) {
          this.endDate = new Date(item.fnoDeactivationDate);
        } else {
          this.endDate = new Date(item.ispDeactivationDate);
        }
      }
      let setDate = new Date(this.setDate);
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / 86400000
      );
      this.startDate = new Date(this.startDate);
      this.endDate = new Date(this.endDate);
      let billedAmount = item.packagesIsp.packagesFno.packageBasePrice;
      this.billedDays = Math.round(
        Math.abs(this.endDate.getTime() - this.startDate.getTime()) / 86400000
      );
      if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Residential"
      ) {
        billedAmount =
          billedAmount -
          item.location.locationNetwork.residentialLineRentalValue;
      } else if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Business"
      ) {
        billedAmount =
          billedAmount - item.location.locationNetwork.businessLineRentalValue;
      }

      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    },
    async sum() {
      let totals = [];
      this.totalSales = 0;
      this.totalCos = 0;
      this.totalExpenses = 0;
      var res = {};

      this.initialTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      await totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < totals[0].length; i++) {
        if (totals[0][i].transactionType === "Sales") {
          this.totalSales = totals[0][i].amount;
        }
        if (totals[0][i].transactionType === "Cost of Sales") {
          this.totalCos = totals[0][i].amount;
        }
        if (totals[0][i].transactionType === "Expense") {
          this.totalExpenses = totals[0][i].amount;
        }
      }
    },
  }

}
</script>

<style>
.truncate {
      max-width: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
</style>